@if (isRefreshActionColumn()) {
  <button
    type="button"
    class="refresh-btn"
    [attr.aria-label]="
      isRefreshDisabled() ? 'Data Refresh in progress' : 'Refresh Data'
    "
    [title]="
      isRefreshDisabled() ? 'Data Refresh in progress' : 'Refresh Data'
    "
    (click)="onRefresh()"
    [disabled]="isRefreshDisabled()"
    [ngClass]="{ 'disabled-refresh': isRefreshDisabled() }"
    style="background: none; border: none; cursor: pointer"
  >
    <span
      class="material-icons"
      [ngClass]="
        isRefreshDisabled() ? 'refresh-disabled' : 'refresh-cisco-blue'
      "
      >refresh</span
    >
  </button>
}

@if (params?.colDef?.headerName === "Job Status") {
  {{ params.value }}&nbsp;
  @if (params.value === "Completed") {
    <span
      class="icon-check-outline icon-small"
      style="vertical-align: bottom"
    ></span>
  }
  @if (params.value === "Failed") {
    <span
      class="icon-presence-end icon-small"
      style="vertical-align: bottom"
    ></span>
  }
}

@if (params?.colDef?.headerName === "Failure Reason") {
  @if (params.data?.jobStatus === "Failed" && params.value) {
    <span class="failure-reason-text">{{ truncateFailureReason(params.value) }}</span>
  }
}

@if (params?.colDef?.headerName === "Source") {
  @if (params.value === "Smart Sheet") {
    <a
      class="grid-renderer-anchor"
      href="{{ params.data.sourceLink }}"
      target="_blank"
      >{{ params.value }}</a
    >
  }
  @if (params.value === "PDAF") {
    {{ params.value }}
    @if (params.data.sourceLink) {
      ({{ params.data.sourceLink }})
    }
  }
  @if (params.value !== "PDAF" && params.value !== "Smart Sheet") {
    {{ params.value }}
  }
}
